module.exports = __webpack_public_path__ + "static/media/panache_relaxed.a62bf518.jpeg";